
import { Component, Input, Self, ChangeDetectorRef } from '@angular/core';
import { ControlValueAccessor, NgModel, NgControl } from '@angular/forms';

@Component({
	selector: 'checkbox',
	templateUrl: "./checkbox.html",
	styles: [require("./checkbox.scss")]
})
export class Checkbox implements ControlValueAccessor {
	@Input('checkboxId') id: string;
	@Input() disableCheckbox: boolean = false;
	@Input() cssClass: string = "";

	private internalModel: boolean;

	constructor(private changeDetectorRef: ChangeDetectorRef, private ngControl: NgControl) {
		ngControl.valueAccessor = this;
	}

	public inputFieldChanged(value: boolean) {
		this.internalModel = value;
		this.updateControlValueAccessor(value);
	}

	writeValue(obj: any): void {
		if (obj || obj === false) {
			this.internalModel = obj
		}
		this.changeDetectorRef.markForCheck();
	}

	registerOnChange(fn: any): void {
		this.controlValueAccessorChanged = fn;
	}

	registerOnTouched(fn: any): void {
		this.controlValueAccessorTouched = fn;
	}

	private updateControlValueAccessor(value: boolean) {
		this.controlValueAccessorTouched();
		if (!value) {
			this.controlValueAccessorChanged(false);
			return;
		}
		this.controlValueAccessorChanged(value);
	}

	private controlValueAccessorChanged = (_) => { };
	private controlValueAccessorTouched = () => { };
}



// WEBPACK FOOTER //
// ./src/app/ui-helper/checkbox/checkbox.component.ts